import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
// import VueQrcode from '@chenfengyuan/vue-qrcode'
import router from './router'
import store from './store'
import wechatShareConfig from '@jin10/utils/lib/wechatShareConfig'
import VueLazyload from 'vue-lazyload'
import VueLoading from 'vue-loading-template'
import pluginDateFormat from './common/date-format'
import Flex from '@/components/Flex.vue'
import {
  rem
} from '@jin10/utils'
import 'assets/style/index.less'
import JsBridge from './plugins/jsBridge'

// todo: 上线记得注释
// import VConsole from 'vconsole'
// new VConsole()

Vue.config.productionTip = false
Vue.prototype.$wechatShareConfig = wechatShareConfig
Vue.prototype.$bridge = new JsBridge()
Vue.component(Flex.name, Flex)

// Vue.component(VueQrcode.name, VueQrcode)
Vue.use(pluginDateFormat)
Vue.use(VueLazyload, {
  // error: 'https://cdn.jin10.com/assets/img/sites/news/lazy-bg.png',
  // loading: 'https://cdn.jin10.com/assets/img/sites/news/lazy-bg.png',
  attempt: 3
})

Vue.use(VueLoading, {
  type: 'spin',
  color: '#F5CB8A',
  size: {
    width: '60px',
    height: '60px'
  }
})

rem({
  baseWidth: 375, // 基准宽度
  baseFontSize: 37.5 // 基准字号
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')